module.exports = __webpack_public_path__ + "img/AS.f252768e.png";